// extracted by mini-css-extract-plugin
export var dark = "y_tl";
export var darkcookie = "y_tm";
export var tintedcookie = "y_tn";
export var regularcookie = "y_tp";
export var darkbase = "y_tq";
export var tintedbase = "y_tr";
export var regularbase = "y_ts";
export var darkraw = "y_tt";
export var tintedraw = "y_tv";
export var regularraw = "y_tw";
export var darkchick = "y_tx";
export var tintedchick = "y_ty";
export var regularchick = "y_tz";
export var darkherbarium = "y_tB";
export var tintedherbarium = "y_tC";
export var regularherbarium = "y_tD";
export var darkholiday = "y_tF";
export var tintedholiday = "y_tG";
export var regularholiday = "y_tH";
export var darkoffline = "y_tJ";
export var tintedoffline = "y_tK";
export var regularoffline = "y_tL";
export var darkorchid = "y_tM";
export var tintedorchid = "y_tN";
export var regularorchid = "y_tP";
export var darkpro = "y_tQ";
export var tintedpro = "y_tR";
export var regularpro = "y_tS";
export var darkrose = "y_tT";
export var tintedrose = "y_tV";
export var regularrose = "y_tW";
export var darktimes = "y_tX";
export var tintedtimes = "y_tY";
export var regulartimes = "y_tZ";
export var darkwagon = "y_t0";
export var tintedwagon = "y_t1";
export var regularwagon = "y_t2";